import styled from "styled-components"
import Dropdown from "react-dropdown"

export const StyledDropdown = styled(Dropdown)`
  .Dropdown-control {
    border-radius: 5px;
  }
`
